import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import fields from '../../lib/fields';

import FormFieldsCompact from '../../components/form/fieldsCompact';

@observer
class EditUsage extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sessionid: new Date().getTime(),
            sections: fields.get('usage'),
        };
        this.mainContainer = null;
    }

    loadAll = async (props = this.props) => {
        const { usageId } = props;
        const { usageStore } = this.props.stores;
        await usageStore.load(usageId, false, { addData: ['parts', 'installations', 'usageers'] });
    }

    // chooseItem = (e) => {
    //     const { idx } = e.target.closest('.similar-item').dataset;
    //     const { partStore } = this.props.stores;
    //     const { foundList } = partStore;
    //     // const item = foundList.find((item) => item.id === parseInt(id, 10));
    //     const item = foundList[parseInt(idx, 10)];
    //     partStore.updateKeyValue('newUsage', {
    //         ...item,
    //     });
    //     partStore.resetSearch();
    // }

    componentDidMount() {
        this.loadAll();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.partId !== this.props.partId) {
            this.loadAll(nextProps);
        }
    }

    componentWillUnmount() {

    }

    render() {
        const { drawerLevel = 1 } = this.props;
        const { sections, isNew = false } = this.state;
        const { usageStore } = this.props.stores;

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100 h-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    <div class='font-weight-lighter px-3 box-header mt-0'>
                        <Text id='part.usage-edit'>Edit Usage</Text>
                    </div>

                    <FormFieldsCompact
                        stores={this.props.stores}
                        sections={sections}
                        holdingStore={usageStore}
                        objectName={'usage'}
                        isNew={isNew}
                        drawerLevel={drawerLevel}
                        isAdmin={false}
                        defaultShowOnlyRecommended={true}
                    />

                </div>
            </div>
        </>);
    }
}

export default EditUsage;
